import {Component} from '@angular/core';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor(
    // private renderer: Renderer2,
    // private el: ElementRef,
    // private option: OptionService,
  ) { }

  public openAndroidLink(): void {
    window.open('https://play.google.com/store/apps/details?id=com.listenandlearnkorean.gukeoapp', '_blank');
  }

  public openAppStoreLink(): void {
    window.open('https://apps.apple.com/app/id6739878324', '_blank');
  }

  // public ToggleLargeMode(): void {
  //   const value = !this.option.largeMode;
  //   this.option.largeMode = value;
  //   SetHtmlLargeMode(this.renderer, this.el, value);
  // }
}
